import { ExtensionTypeLayer } from './ExtensionTypeLayer';
import { GroupLayer } from './GroupLayer';
import { FieldDefinitionLayer } from './FieldDefinitionLayer';

export { ExtensionTypeLayer, GroupLayer, FieldDefinitionLayer };

const FieldDefinitionEditor = ExtensionTypeLayer;
export default FieldDefinitionEditor;